import { getFullNameUser } from 'Helpers/avatarHelper.js';
import { getOverviewPathFromType } from 'Dictionaries/overviewPath.js';
const adaptRelatedForActivity = (related) => {
    let name = '';
    const type = related.type;
    const subtype = related.subtype ?? related.type;
    let object = related.type;
    let status = related.status;
    switch (related.type) {
        case 'contact':
            name = getFullNameUser(related);
            break;
        case 'individual':
            name = getFullNameUser(related) || related.name;
            break;
        case 'estimate':
        case 'creditnote':
        case 'invoice':
        case 'order':
            name = related.number || related.docnumber;
            object = 'document';
            status = related.step;
            break;
        default:
            name = related.name;
    }
    return {
        name,
        id: related.id,
        status,
        type,
        subtype,
        object,
        link: getOverviewPathFromType({ type, id: related.id, subType: subtype }),
    };
};

export { adaptRelatedForActivity };
